/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthImpersonateRouteImport } from './routes/auth.impersonate'
import { Route as AuthTeamsRouteImport } from './routes/_auth.teams'
import { Route as AuthMonitorRouteImport } from './routes/_auth.monitor'
import { Route as AuthInboxRouteImport } from './routes/_auth.inbox'
import { Route as AuthHitlRouteImport } from './routes/_auth.hitl'
import { Route as AuthHandoffsRouteImport } from './routes/_auth.handoffs'
import { Route as AuthGuardrailsRouteImport } from './routes/_auth.guardrails'
import { Route as AuthDashboardRouteImport } from './routes/_auth.dashboard'
import { Route as AuthChannelsRouteImport } from './routes/_auth.channels'
import { Route as AuthBillingRouteImport } from './routes/_auth.billing'
import { Route as AuthApprovalsRouteImport } from './routes/_auth.approvals'
import { Route as AuthAnalyticsRouteImport } from './routes/_auth.analytics'
import { Route as AuthAlertsRouteImport } from './routes/_auth.alerts'
import { Route as AuthWorkflowsIndexRouteImport } from './routes/_auth.workflows.index'
import { Route as AuthTriggersIndexRouteImport } from './routes/_auth.triggers.index'
import { Route as AuthSkillsIndexRouteImport } from './routes/_auth.skills.index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth.settings.index'
import { Route as AuthKnowledgeIndexRouteImport } from './routes/_auth.knowledge.index'
import { Route as AuthEventConnectorsIndexRouteImport } from './routes/_auth.event-connectors.index'
import { Route as AuthConversationsIndexRouteImport } from './routes/_auth.conversations.index'
import { Route as AuthAgentsIndexRouteImport } from './routes/_auth.agents.index'
import { Route as AuthWorkflowsWorkflowIdRouteImport } from './routes/_auth.workflows.$workflowId'
import { Route as AuthTriggersTriggerIdRouteImport } from './routes/_auth.triggers.$triggerId'
import { Route as AuthSkillsSkillIdRouteImport } from './routes/_auth.skills.$skillId'
import { Route as AuthSettingsVoiceRouteImport } from './routes/_auth.settings.voice'
import { Route as AuthSettingsToolsCatalogRouteImport } from './routes/_auth.settings.tools-catalog'
import { Route as AuthSettingsToolsRouteImport } from './routes/_auth.settings.tools'
import { Route as AuthSettingsSecretsRouteImport } from './routes/_auth.settings.secrets'
import { Route as AuthSettingsMembersRouteImport } from './routes/_auth.settings.members'
import { Route as AuthSettingsLlmProvidersRouteImport } from './routes/_auth.settings.llm-providers'
import { Route as AuthSettingsIntegrationsRouteImport } from './routes/_auth.settings.integrations'
import { Route as AuthSettingsEmailConnectorsRouteImport } from './routes/_auth.settings.email-connectors'
import { Route as AuthSettingsAuditLogRouteImport } from './routes/_auth.settings.audit-log'
import { Route as AuthSettingsApiKeysRouteImport } from './routes/_auth.settings.api-keys'
import { Route as AuthKnowledgeSourceIdRouteImport } from './routes/_auth.knowledge.$sourceId'
import { Route as AuthConversationsConversationIdRouteImport } from './routes/_auth.conversations.$conversationId'
import { Route as AuthAgentsNewRouteImport } from './routes/_auth.agents.new'
import { Route as AuthAgentsAgentIdRouteImport } from './routes/_auth.agents.$agentId'
import { Route as AuthWorkflowsExecutionsExecutionIdRouteImport } from './routes/_auth.workflows.executions.$executionId'
import { Route as AuthKnowledgeSourceIdArticlesArticleIdRouteImport } from './routes/_auth.knowledge.$sourceId.articles.$articleId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthImpersonateRoute = AuthImpersonateRouteImport.update({
  id: '/auth/impersonate',
  path: '/auth/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthTeamsRoute = AuthTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMonitorRoute = AuthMonitorRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInboxRoute = AuthInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHitlRoute = AuthHitlRouteImport.update({
  id: '/hitl',
  path: '/hitl',
  getParentRoute: () => AuthRoute,
} as any)
const AuthHandoffsRoute = AuthHandoffsRouteImport.update({
  id: '/handoffs',
  path: '/handoffs',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGuardrailsRoute = AuthGuardrailsRouteImport.update({
  id: '/guardrails',
  path: '/guardrails',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChannelsRoute = AuthChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthApprovalsRoute = AuthApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAnalyticsRoute = AuthAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAlertsRoute = AuthAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkflowsIndexRoute = AuthWorkflowsIndexRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTriggersIndexRoute = AuthTriggersIndexRouteImport.update({
  id: '/triggers/',
  path: '/triggers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSkillsIndexRoute = AuthSkillsIndexRouteImport.update({
  id: '/skills/',
  path: '/skills/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKnowledgeIndexRoute = AuthKnowledgeIndexRouteImport.update({
  id: '/knowledge/',
  path: '/knowledge/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEventConnectorsIndexRoute =
  AuthEventConnectorsIndexRouteImport.update({
    id: '/event-connectors/',
    path: '/event-connectors/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConversationsIndexRoute = AuthConversationsIndexRouteImport.update({
  id: '/conversations/',
  path: '/conversations/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsIndexRoute = AuthAgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkflowsWorkflowIdRoute = AuthWorkflowsWorkflowIdRouteImport.update({
  id: '/workflows/$workflowId',
  path: '/workflows/$workflowId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthTriggersTriggerIdRoute = AuthTriggersTriggerIdRouteImport.update({
  id: '/triggers/$triggerId',
  path: '/triggers/$triggerId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSkillsSkillIdRoute = AuthSkillsSkillIdRouteImport.update({
  id: '/skills/$skillId',
  path: '/skills/$skillId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsVoiceRoute = AuthSettingsVoiceRouteImport.update({
  id: '/settings/voice',
  path: '/settings/voice',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsToolsCatalogRoute =
  AuthSettingsToolsCatalogRouteImport.update({
    id: '/settings/tools-catalog',
    path: '/settings/tools-catalog',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsToolsRoute = AuthSettingsToolsRouteImport.update({
  id: '/settings/tools',
  path: '/settings/tools',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsSecretsRoute = AuthSettingsSecretsRouteImport.update({
  id: '/settings/secrets',
  path: '/settings/secrets',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsMembersRoute = AuthSettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsLlmProvidersRoute =
  AuthSettingsLlmProvidersRouteImport.update({
    id: '/settings/llm-providers',
    path: '/settings/llm-providers',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsIntegrationsRoute =
  AuthSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsEmailConnectorsRoute =
  AuthSettingsEmailConnectorsRouteImport.update({
    id: '/settings/email-connectors',
    path: '/settings/email-connectors',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSettingsAuditLogRoute = AuthSettingsAuditLogRouteImport.update({
  id: '/settings/audit-log',
  path: '/settings/audit-log',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsApiKeysRoute = AuthSettingsApiKeysRouteImport.update({
  id: '/settings/api-keys',
  path: '/settings/api-keys',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKnowledgeSourceIdRoute = AuthKnowledgeSourceIdRouteImport.update({
  id: '/knowledge/$sourceId',
  path: '/knowledge/$sourceId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthConversationsConversationIdRoute =
  AuthConversationsConversationIdRouteImport.update({
    id: '/conversations/$conversationId',
    path: '/conversations/$conversationId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAgentsNewRoute = AuthAgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgentsAgentIdRoute = AuthAgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWorkflowsExecutionsExecutionIdRoute =
  AuthWorkflowsExecutionsExecutionIdRouteImport.update({
    id: '/workflows/executions/$executionId',
    path: '/workflows/executions/$executionId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthKnowledgeSourceIdArticlesArticleIdRoute =
  AuthKnowledgeSourceIdArticlesArticleIdRouteImport.update({
    id: '/articles/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => AuthKnowledgeSourceIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AuthAlertsRoute
  '/analytics': typeof AuthAnalyticsRoute
  '/approvals': typeof AuthApprovalsRoute
  '/billing': typeof AuthBillingRoute
  '/channels': typeof AuthChannelsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/guardrails': typeof AuthGuardrailsRoute
  '/handoffs': typeof AuthHandoffsRoute
  '/hitl': typeof AuthHitlRoute
  '/inbox': typeof AuthInboxRoute
  '/monitor': typeof AuthMonitorRoute
  '/teams': typeof AuthTeamsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/agents/new': typeof AuthAgentsNewRoute
  '/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/knowledge/$sourceId': typeof AuthKnowledgeSourceIdRouteWithChildren
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/settings/email-connectors': typeof AuthSettingsEmailConnectorsRoute
  '/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/settings/members': typeof AuthSettingsMembersRoute
  '/settings/secrets': typeof AuthSettingsSecretsRoute
  '/settings/tools': typeof AuthSettingsToolsRoute
  '/settings/tools-catalog': typeof AuthSettingsToolsCatalogRoute
  '/settings/voice': typeof AuthSettingsVoiceRoute
  '/skills/$skillId': typeof AuthSkillsSkillIdRoute
  '/triggers/$triggerId': typeof AuthTriggersTriggerIdRoute
  '/workflows/$workflowId': typeof AuthWorkflowsWorkflowIdRoute
  '/agents/': typeof AuthAgentsIndexRoute
  '/conversations/': typeof AuthConversationsIndexRoute
  '/event-connectors/': typeof AuthEventConnectorsIndexRoute
  '/knowledge/': typeof AuthKnowledgeIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/skills/': typeof AuthSkillsIndexRoute
  '/triggers/': typeof AuthTriggersIndexRoute
  '/workflows/': typeof AuthWorkflowsIndexRoute
  '/workflows/executions/$executionId': typeof AuthWorkflowsExecutionsExecutionIdRoute
  '/knowledge/$sourceId/articles/$articleId': typeof AuthKnowledgeSourceIdArticlesArticleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/alerts': typeof AuthAlertsRoute
  '/analytics': typeof AuthAnalyticsRoute
  '/approvals': typeof AuthApprovalsRoute
  '/billing': typeof AuthBillingRoute
  '/channels': typeof AuthChannelsRoute
  '/dashboard': typeof AuthDashboardRoute
  '/guardrails': typeof AuthGuardrailsRoute
  '/handoffs': typeof AuthHandoffsRoute
  '/hitl': typeof AuthHitlRoute
  '/inbox': typeof AuthInboxRoute
  '/monitor': typeof AuthMonitorRoute
  '/teams': typeof AuthTeamsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/agents/new': typeof AuthAgentsNewRoute
  '/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/knowledge/$sourceId': typeof AuthKnowledgeSourceIdRouteWithChildren
  '/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/settings/email-connectors': typeof AuthSettingsEmailConnectorsRoute
  '/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/settings/members': typeof AuthSettingsMembersRoute
  '/settings/secrets': typeof AuthSettingsSecretsRoute
  '/settings/tools': typeof AuthSettingsToolsRoute
  '/settings/tools-catalog': typeof AuthSettingsToolsCatalogRoute
  '/settings/voice': typeof AuthSettingsVoiceRoute
  '/skills/$skillId': typeof AuthSkillsSkillIdRoute
  '/triggers/$triggerId': typeof AuthTriggersTriggerIdRoute
  '/workflows/$workflowId': typeof AuthWorkflowsWorkflowIdRoute
  '/agents': typeof AuthAgentsIndexRoute
  '/conversations': typeof AuthConversationsIndexRoute
  '/event-connectors': typeof AuthEventConnectorsIndexRoute
  '/knowledge': typeof AuthKnowledgeIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/skills': typeof AuthSkillsIndexRoute
  '/triggers': typeof AuthTriggersIndexRoute
  '/workflows': typeof AuthWorkflowsIndexRoute
  '/workflows/executions/$executionId': typeof AuthWorkflowsExecutionsExecutionIdRoute
  '/knowledge/$sourceId/articles/$articleId': typeof AuthKnowledgeSourceIdArticlesArticleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/alerts': typeof AuthAlertsRoute
  '/_auth/analytics': typeof AuthAnalyticsRoute
  '/_auth/approvals': typeof AuthApprovalsRoute
  '/_auth/billing': typeof AuthBillingRoute
  '/_auth/channels': typeof AuthChannelsRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/guardrails': typeof AuthGuardrailsRoute
  '/_auth/handoffs': typeof AuthHandoffsRoute
  '/_auth/hitl': typeof AuthHitlRoute
  '/_auth/inbox': typeof AuthInboxRoute
  '/_auth/monitor': typeof AuthMonitorRoute
  '/_auth/teams': typeof AuthTeamsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/_auth/agents/$agentId': typeof AuthAgentsAgentIdRoute
  '/_auth/agents/new': typeof AuthAgentsNewRoute
  '/_auth/conversations/$conversationId': typeof AuthConversationsConversationIdRoute
  '/_auth/knowledge/$sourceId': typeof AuthKnowledgeSourceIdRouteWithChildren
  '/_auth/settings/api-keys': typeof AuthSettingsApiKeysRoute
  '/_auth/settings/audit-log': typeof AuthSettingsAuditLogRoute
  '/_auth/settings/email-connectors': typeof AuthSettingsEmailConnectorsRoute
  '/_auth/settings/integrations': typeof AuthSettingsIntegrationsRoute
  '/_auth/settings/llm-providers': typeof AuthSettingsLlmProvidersRoute
  '/_auth/settings/members': typeof AuthSettingsMembersRoute
  '/_auth/settings/secrets': typeof AuthSettingsSecretsRoute
  '/_auth/settings/tools': typeof AuthSettingsToolsRoute
  '/_auth/settings/tools-catalog': typeof AuthSettingsToolsCatalogRoute
  '/_auth/settings/voice': typeof AuthSettingsVoiceRoute
  '/_auth/skills/$skillId': typeof AuthSkillsSkillIdRoute
  '/_auth/triggers/$triggerId': typeof AuthTriggersTriggerIdRoute
  '/_auth/workflows/$workflowId': typeof AuthWorkflowsWorkflowIdRoute
  '/_auth/agents/': typeof AuthAgentsIndexRoute
  '/_auth/conversations/': typeof AuthConversationsIndexRoute
  '/_auth/event-connectors/': typeof AuthEventConnectorsIndexRoute
  '/_auth/knowledge/': typeof AuthKnowledgeIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/skills/': typeof AuthSkillsIndexRoute
  '/_auth/triggers/': typeof AuthTriggersIndexRoute
  '/_auth/workflows/': typeof AuthWorkflowsIndexRoute
  '/_auth/workflows/executions/$executionId': typeof AuthWorkflowsExecutionsExecutionIdRoute
  '/_auth/knowledge/$sourceId/articles/$articleId': typeof AuthKnowledgeSourceIdArticlesArticleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/alerts'
    | '/analytics'
    | '/approvals'
    | '/billing'
    | '/channels'
    | '/dashboard'
    | '/guardrails'
    | '/handoffs'
    | '/hitl'
    | '/inbox'
    | '/monitor'
    | '/teams'
    | '/auth/impersonate'
    | '/agents/$agentId'
    | '/agents/new'
    | '/conversations/$conversationId'
    | '/knowledge/$sourceId'
    | '/settings/api-keys'
    | '/settings/audit-log'
    | '/settings/email-connectors'
    | '/settings/integrations'
    | '/settings/llm-providers'
    | '/settings/members'
    | '/settings/secrets'
    | '/settings/tools'
    | '/settings/tools-catalog'
    | '/settings/voice'
    | '/skills/$skillId'
    | '/triggers/$triggerId'
    | '/workflows/$workflowId'
    | '/agents/'
    | '/conversations/'
    | '/event-connectors/'
    | '/knowledge/'
    | '/settings/'
    | '/skills/'
    | '/triggers/'
    | '/workflows/'
    | '/workflows/executions/$executionId'
    | '/knowledge/$sourceId/articles/$articleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/alerts'
    | '/analytics'
    | '/approvals'
    | '/billing'
    | '/channels'
    | '/dashboard'
    | '/guardrails'
    | '/handoffs'
    | '/hitl'
    | '/inbox'
    | '/monitor'
    | '/teams'
    | '/auth/impersonate'
    | '/agents/$agentId'
    | '/agents/new'
    | '/conversations/$conversationId'
    | '/knowledge/$sourceId'
    | '/settings/api-keys'
    | '/settings/audit-log'
    | '/settings/email-connectors'
    | '/settings/integrations'
    | '/settings/llm-providers'
    | '/settings/members'
    | '/settings/secrets'
    | '/settings/tools'
    | '/settings/tools-catalog'
    | '/settings/voice'
    | '/skills/$skillId'
    | '/triggers/$triggerId'
    | '/workflows/$workflowId'
    | '/agents'
    | '/conversations'
    | '/event-connectors'
    | '/knowledge'
    | '/settings'
    | '/skills'
    | '/triggers'
    | '/workflows'
    | '/workflows/executions/$executionId'
    | '/knowledge/$sourceId/articles/$articleId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/alerts'
    | '/_auth/analytics'
    | '/_auth/approvals'
    | '/_auth/billing'
    | '/_auth/channels'
    | '/_auth/dashboard'
    | '/_auth/guardrails'
    | '/_auth/handoffs'
    | '/_auth/hitl'
    | '/_auth/inbox'
    | '/_auth/monitor'
    | '/_auth/teams'
    | '/auth/impersonate'
    | '/_auth/agents/$agentId'
    | '/_auth/agents/new'
    | '/_auth/conversations/$conversationId'
    | '/_auth/knowledge/$sourceId'
    | '/_auth/settings/api-keys'
    | '/_auth/settings/audit-log'
    | '/_auth/settings/email-connectors'
    | '/_auth/settings/integrations'
    | '/_auth/settings/llm-providers'
    | '/_auth/settings/members'
    | '/_auth/settings/secrets'
    | '/_auth/settings/tools'
    | '/_auth/settings/tools-catalog'
    | '/_auth/settings/voice'
    | '/_auth/skills/$skillId'
    | '/_auth/triggers/$triggerId'
    | '/_auth/workflows/$workflowId'
    | '/_auth/agents/'
    | '/_auth/conversations/'
    | '/_auth/event-connectors/'
    | '/_auth/knowledge/'
    | '/_auth/settings/'
    | '/_auth/skills/'
    | '/_auth/triggers/'
    | '/_auth/workflows/'
    | '/_auth/workflows/executions/$executionId'
    | '/_auth/knowledge/$sourceId/articles/$articleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthImpersonateRoute: typeof AuthImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/impersonate': {
      id: '/auth/impersonate'
      path: '/auth/impersonate'
      fullPath: '/auth/impersonate'
      preLoaderRoute: typeof AuthImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/teams': {
      id: '/_auth/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AuthTeamsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/monitor': {
      id: '/_auth/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof AuthMonitorRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/inbox': {
      id: '/_auth/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthInboxRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/hitl': {
      id: '/_auth/hitl'
      path: '/hitl'
      fullPath: '/hitl'
      preLoaderRoute: typeof AuthHitlRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/handoffs': {
      id: '/_auth/handoffs'
      path: '/handoffs'
      fullPath: '/handoffs'
      preLoaderRoute: typeof AuthHandoffsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/guardrails': {
      id: '/_auth/guardrails'
      path: '/guardrails'
      fullPath: '/guardrails'
      preLoaderRoute: typeof AuthGuardrailsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/channels': {
      id: '/_auth/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof AuthChannelsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/approvals': {
      id: '/_auth/approvals'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof AuthApprovalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/analytics': {
      id: '/_auth/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthAnalyticsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/alerts': {
      id: '/_auth/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthAlertsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workflows/': {
      id: '/_auth/workflows/'
      path: '/workflows'
      fullPath: '/workflows/'
      preLoaderRoute: typeof AuthWorkflowsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/triggers/': {
      id: '/_auth/triggers/'
      path: '/triggers'
      fullPath: '/triggers/'
      preLoaderRoute: typeof AuthTriggersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/skills/': {
      id: '/_auth/skills/'
      path: '/skills'
      fullPath: '/skills/'
      preLoaderRoute: typeof AuthSkillsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/knowledge/': {
      id: '/_auth/knowledge/'
      path: '/knowledge'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof AuthKnowledgeIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/event-connectors/': {
      id: '/_auth/event-connectors/'
      path: '/event-connectors'
      fullPath: '/event-connectors/'
      preLoaderRoute: typeof AuthEventConnectorsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conversations/': {
      id: '/_auth/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AuthConversationsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/': {
      id: '/_auth/agents/'
      path: '/agents'
      fullPath: '/agents/'
      preLoaderRoute: typeof AuthAgentsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workflows/$workflowId': {
      id: '/_auth/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof AuthWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/triggers/$triggerId': {
      id: '/_auth/triggers/$triggerId'
      path: '/triggers/$triggerId'
      fullPath: '/triggers/$triggerId'
      preLoaderRoute: typeof AuthTriggersTriggerIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/skills/$skillId': {
      id: '/_auth/skills/$skillId'
      path: '/skills/$skillId'
      fullPath: '/skills/$skillId'
      preLoaderRoute: typeof AuthSkillsSkillIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/voice': {
      id: '/_auth/settings/voice'
      path: '/settings/voice'
      fullPath: '/settings/voice'
      preLoaderRoute: typeof AuthSettingsVoiceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/tools-catalog': {
      id: '/_auth/settings/tools-catalog'
      path: '/settings/tools-catalog'
      fullPath: '/settings/tools-catalog'
      preLoaderRoute: typeof AuthSettingsToolsCatalogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/tools': {
      id: '/_auth/settings/tools'
      path: '/settings/tools'
      fullPath: '/settings/tools'
      preLoaderRoute: typeof AuthSettingsToolsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/secrets': {
      id: '/_auth/settings/secrets'
      path: '/settings/secrets'
      fullPath: '/settings/secrets'
      preLoaderRoute: typeof AuthSettingsSecretsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/members': {
      id: '/_auth/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthSettingsMembersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/llm-providers': {
      id: '/_auth/settings/llm-providers'
      path: '/settings/llm-providers'
      fullPath: '/settings/llm-providers'
      preLoaderRoute: typeof AuthSettingsLlmProvidersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/integrations': {
      id: '/_auth/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AuthSettingsIntegrationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/email-connectors': {
      id: '/_auth/settings/email-connectors'
      path: '/settings/email-connectors'
      fullPath: '/settings/email-connectors'
      preLoaderRoute: typeof AuthSettingsEmailConnectorsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/audit-log': {
      id: '/_auth/settings/audit-log'
      path: '/settings/audit-log'
      fullPath: '/settings/audit-log'
      preLoaderRoute: typeof AuthSettingsAuditLogRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/api-keys': {
      id: '/_auth/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthSettingsApiKeysRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/knowledge/$sourceId': {
      id: '/_auth/knowledge/$sourceId'
      path: '/knowledge/$sourceId'
      fullPath: '/knowledge/$sourceId'
      preLoaderRoute: typeof AuthKnowledgeSourceIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/conversations/$conversationId': {
      id: '/_auth/conversations/$conversationId'
      path: '/conversations/$conversationId'
      fullPath: '/conversations/$conversationId'
      preLoaderRoute: typeof AuthConversationsConversationIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/new': {
      id: '/_auth/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AuthAgentsNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agents/$agentId': {
      id: '/_auth/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AuthAgentsAgentIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/workflows/executions/$executionId': {
      id: '/_auth/workflows/executions/$executionId'
      path: '/workflows/executions/$executionId'
      fullPath: '/workflows/executions/$executionId'
      preLoaderRoute: typeof AuthWorkflowsExecutionsExecutionIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/knowledge/$sourceId/articles/$articleId': {
      id: '/_auth/knowledge/$sourceId/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/knowledge/$sourceId/articles/$articleId'
      preLoaderRoute: typeof AuthKnowledgeSourceIdArticlesArticleIdRouteImport
      parentRoute: typeof AuthKnowledgeSourceIdRoute
    }
  }
}

interface AuthKnowledgeSourceIdRouteChildren {
  AuthKnowledgeSourceIdArticlesArticleIdRoute: typeof AuthKnowledgeSourceIdArticlesArticleIdRoute
}

const AuthKnowledgeSourceIdRouteChildren: AuthKnowledgeSourceIdRouteChildren = {
  AuthKnowledgeSourceIdArticlesArticleIdRoute:
    AuthKnowledgeSourceIdArticlesArticleIdRoute,
}

const AuthKnowledgeSourceIdRouteWithChildren =
  AuthKnowledgeSourceIdRoute._addFileChildren(
    AuthKnowledgeSourceIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthAlertsRoute: typeof AuthAlertsRoute
  AuthAnalyticsRoute: typeof AuthAnalyticsRoute
  AuthApprovalsRoute: typeof AuthApprovalsRoute
  AuthBillingRoute: typeof AuthBillingRoute
  AuthChannelsRoute: typeof AuthChannelsRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthGuardrailsRoute: typeof AuthGuardrailsRoute
  AuthHandoffsRoute: typeof AuthHandoffsRoute
  AuthHitlRoute: typeof AuthHitlRoute
  AuthInboxRoute: typeof AuthInboxRoute
  AuthMonitorRoute: typeof AuthMonitorRoute
  AuthTeamsRoute: typeof AuthTeamsRoute
  AuthAgentsAgentIdRoute: typeof AuthAgentsAgentIdRoute
  AuthAgentsNewRoute: typeof AuthAgentsNewRoute
  AuthConversationsConversationIdRoute: typeof AuthConversationsConversationIdRoute
  AuthKnowledgeSourceIdRoute: typeof AuthKnowledgeSourceIdRouteWithChildren
  AuthSettingsApiKeysRoute: typeof AuthSettingsApiKeysRoute
  AuthSettingsAuditLogRoute: typeof AuthSettingsAuditLogRoute
  AuthSettingsEmailConnectorsRoute: typeof AuthSettingsEmailConnectorsRoute
  AuthSettingsIntegrationsRoute: typeof AuthSettingsIntegrationsRoute
  AuthSettingsLlmProvidersRoute: typeof AuthSettingsLlmProvidersRoute
  AuthSettingsMembersRoute: typeof AuthSettingsMembersRoute
  AuthSettingsSecretsRoute: typeof AuthSettingsSecretsRoute
  AuthSettingsToolsRoute: typeof AuthSettingsToolsRoute
  AuthSettingsToolsCatalogRoute: typeof AuthSettingsToolsCatalogRoute
  AuthSettingsVoiceRoute: typeof AuthSettingsVoiceRoute
  AuthSkillsSkillIdRoute: typeof AuthSkillsSkillIdRoute
  AuthTriggersTriggerIdRoute: typeof AuthTriggersTriggerIdRoute
  AuthWorkflowsWorkflowIdRoute: typeof AuthWorkflowsWorkflowIdRoute
  AuthAgentsIndexRoute: typeof AuthAgentsIndexRoute
  AuthConversationsIndexRoute: typeof AuthConversationsIndexRoute
  AuthEventConnectorsIndexRoute: typeof AuthEventConnectorsIndexRoute
  AuthKnowledgeIndexRoute: typeof AuthKnowledgeIndexRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
  AuthSkillsIndexRoute: typeof AuthSkillsIndexRoute
  AuthTriggersIndexRoute: typeof AuthTriggersIndexRoute
  AuthWorkflowsIndexRoute: typeof AuthWorkflowsIndexRoute
  AuthWorkflowsExecutionsExecutionIdRoute: typeof AuthWorkflowsExecutionsExecutionIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAlertsRoute: AuthAlertsRoute,
  AuthAnalyticsRoute: AuthAnalyticsRoute,
  AuthApprovalsRoute: AuthApprovalsRoute,
  AuthBillingRoute: AuthBillingRoute,
  AuthChannelsRoute: AuthChannelsRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthGuardrailsRoute: AuthGuardrailsRoute,
  AuthHandoffsRoute: AuthHandoffsRoute,
  AuthHitlRoute: AuthHitlRoute,
  AuthInboxRoute: AuthInboxRoute,
  AuthMonitorRoute: AuthMonitorRoute,
  AuthTeamsRoute: AuthTeamsRoute,
  AuthAgentsAgentIdRoute: AuthAgentsAgentIdRoute,
  AuthAgentsNewRoute: AuthAgentsNewRoute,
  AuthConversationsConversationIdRoute: AuthConversationsConversationIdRoute,
  AuthKnowledgeSourceIdRoute: AuthKnowledgeSourceIdRouteWithChildren,
  AuthSettingsApiKeysRoute: AuthSettingsApiKeysRoute,
  AuthSettingsAuditLogRoute: AuthSettingsAuditLogRoute,
  AuthSettingsEmailConnectorsRoute: AuthSettingsEmailConnectorsRoute,
  AuthSettingsIntegrationsRoute: AuthSettingsIntegrationsRoute,
  AuthSettingsLlmProvidersRoute: AuthSettingsLlmProvidersRoute,
  AuthSettingsMembersRoute: AuthSettingsMembersRoute,
  AuthSettingsSecretsRoute: AuthSettingsSecretsRoute,
  AuthSettingsToolsRoute: AuthSettingsToolsRoute,
  AuthSettingsToolsCatalogRoute: AuthSettingsToolsCatalogRoute,
  AuthSettingsVoiceRoute: AuthSettingsVoiceRoute,
  AuthSkillsSkillIdRoute: AuthSkillsSkillIdRoute,
  AuthTriggersTriggerIdRoute: AuthTriggersTriggerIdRoute,
  AuthWorkflowsWorkflowIdRoute: AuthWorkflowsWorkflowIdRoute,
  AuthAgentsIndexRoute: AuthAgentsIndexRoute,
  AuthConversationsIndexRoute: AuthConversationsIndexRoute,
  AuthEventConnectorsIndexRoute: AuthEventConnectorsIndexRoute,
  AuthKnowledgeIndexRoute: AuthKnowledgeIndexRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
  AuthSkillsIndexRoute: AuthSkillsIndexRoute,
  AuthTriggersIndexRoute: AuthTriggersIndexRoute,
  AuthWorkflowsIndexRoute: AuthWorkflowsIndexRoute,
  AuthWorkflowsExecutionsExecutionIdRoute:
    AuthWorkflowsExecutionsExecutionIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthImpersonateRoute: AuthImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
